module.exports = __webpack_public_path__ + "img/evelyncs-neg@2x.7d8e21cf.svg";